export default __webpack_public_path__ + "static/media/portfolio-hover-174.d4601d9c.jpg";